// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".pay-coin-icon{width:.42667rem;height:.42667rem;margin:0 .02667rem}", ""]);
// Exports
module.exports = exports;
